'use client';

import {DatePicker} from '@/matic/components/ui/date-picker';

type DateFieldProps = {
  value: unknown;
  onChange: (value: unknown) => void;
  error?: string;
  disabled?: boolean;
  label: string;
  required?: boolean;
};

export function DateField({
  value,
  onChange,
  error,
  disabled,
  label,
  required,
}: DateFieldProps) {
  // Normalise ISO timestamps to YYYY-MM-DD before passing to DatePicker
  const dateValue =
    typeof value === 'string' && value ? value.split('T')[0] : undefined;

  return (
    <div>
      <label className="mb-1 block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500"> *</span>}
      </label>
      <DatePicker
        value={dateValue}
        onChange={(v) => {
          onChange(v || null);
        }}
        disabled={disabled}
        placeholder="Select date"
      />
      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
}
